module.exports = __webpack_public_path__ + "img/bg1.a73986c0.png";